import { render, staticRenderFns } from "./BatchUpdate.vue?vue&type=template&id=4d9a9142&"
import script from "./BatchUpdate.vue?vue&type=script&lang=js&"
export * from "./BatchUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BatchUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports